/**
 * Returns date as December 22, 2022
 */
export const formatTimestamp = (timestamp: number): string => {
  try {
    return new Date(timestamp * 1000).toLocaleDateString('en-us', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      timeZone: 'UTC',
    });
  } catch (er) {
    // eslint-disable-next-line no-console
    console.warn('Unable to parse visit date', er);
  }
  return '';
};

/**
 * Returns date as December 22, 2022
 */
export const formatDate = (date: string, locale: string = 'en-us'): string => {
  try {
    return new Date(date).toLocaleDateString(locale, {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      timeZone: 'UTC',
    });
  } catch (er) {
    // eslint-disable-next-line no-console
    console.warn('Unable to parse date', er);
  }
  return '';
};

/**
 * Returns date as June 2
 */
export const formatMonthDate = (
  date: string,
  locale: string = 'en-us',
): string => {
  try {
    return new Date(date).toLocaleDateString(locale, {
      month: 'long',
      day: 'numeric',
      timeZone: 'UTC',
    });
  } catch (er) {
    // eslint-disable-next-line no-console
    console.warn('Unable to parse date', er);
  }
  return '';
};

/**
 * Returns date as December 22, 2022, 1:00 PM
 */
export const formatFullDateTime = (
  date: string,
  locale: string = 'en',
): string => {
  try {
    return new Intl.DateTimeFormat(locale, {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      timeZone: 'UTC',
    }).format(Date.parse(date));
  } catch (er) {
    // eslint-disable-next-line no-console
    console.warn('Unable to parse date', er);
  }
  return '';
};

export const formatMonthName = (
  date: Date,
  locale: string = 'en-us',
): string => {
  try {
    return date.toLocaleDateString(locale, {
      month: 'long',
    });
  } catch (er) {
    // eslint-disable-next-line no-console
    console.warn('Unable to parse date', er);
  }
  return '';
};

/**
 * Returns date as 12/25/2022
 */
export const shortFormatDate = (
  date: string,
  locale: string = 'en-us',
): string => {
  try {
    return new Date(date).toLocaleDateString(locale, {
      timeZone: 'UTC',
    });
  } catch (er) {
    // eslint-disable-next-line no-console
    console.warn('Unable to parse date', er);
  }
  return '';
};

/**
 * Returns date as May 29 at 1:00 PM
 */
export const formatMonthDateTime = (date: string): string => {
  try {
    const formattedDate = new Date(date);
    const month = formattedDate.toLocaleDateString('en-us', { month: 'long' });
    const day = formattedDate.toLocaleDateString('en-us', { day: 'numeric' });
    const time = formattedDate.toLocaleTimeString('en-us', {
      hour: 'numeric',
      minute: 'numeric',
    });
    return `${month} ${day} at ${time}`;
  } catch (er) {
    // eslint-disable-next-line no-console
    console.warn('Unable to parse date', er);
  }
  return '';
};
